import { createAction, props } from '@ngrx/store';
import { User } from '../../models/Doctor';

export const loggedIn = createAction('User Logged In', props<{ access_token: string }>());
export const logout = createAction('User Logged Out');
export const gotPermissions = createAction('User got permissions', props<{ permissions: any[] }>());
export const setUserData = createAction('Set user data', props<{ userData: any }>());
